import { CheckoutExperienceZodSchema } from "@redotech/redo-conversion-core-common/redo-in-shipping/ris";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCheckoutExperienceById = {
  name: "getCheckoutExperienceById" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: CheckoutExperienceZodSchema,
};
